import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useClassificacaoServicoPrestado from "core/features/cnae/hooks/useClassificacaoServicoPrestado";

export interface SelectClassificacaoServicoPrestadoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectClassificacaoServicoPrestado({
  value,
  onChange,
  ...rest
}: SelectClassificacaoServicoPrestadoProps) {
  const { isLoading, data } = useClassificacaoServicoPrestado();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: `${item.codigo}  ${item.nome}`,
      }))}
      {...rest}
    />
  );
}

export default SelectClassificacaoServicoPrestado;
